import { render, staticRenderFns } from "./BaseUpload.vue?vue&type=template&id=83205d8e&scoped=true"
import script from "./BaseUpload.vue?vue&type=script&lang=js"
export * from "./BaseUpload.vue?vue&type=script&lang=js"
import style0 from "./BaseUpload.vue?vue&type=style&index=0&id=83205d8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83205d8e",
  null
  
)

export default component.exports